import React from 'react';
import { Col, Row } from 'reactstrap';
import { OperationalToleranceSectionValue } from '../../../../shared/offer-domain/ui';
import { displayValue } from '../../utils/formatters';
import { getProductLabel } from '../../utils/offerHeader';
import { offerToleranceProcurement } from '../../utils/roomSpec';
import RoomPanel from './RoomPanel';

const Fact = ({ label, children }) => (
  <Col md={6} xl={3}>
    <div className='text-muted fw-semibold fs-12 mb-1'>{label}</div>
    <div className='text-dark'>{children}</div>
  </Col>
);

const GeneralInfoSection = ({ cargo, partner, procurement }) => (
  <RoomPanel
    title='General information'
    description='Product, quantity, offer and operation tolerance for this room'
    icon='ri-information-line'
  >
    <Row className='g-3'>
      <Fact label='Product name'>
        {displayValue(getProductLabel(procurement))}
      </Fact>
      <Fact label='Quantity'>
        {displayValue(cargo?.requirement?.cargo?.volume)}
      </Fact>
      <Fact label={partner?.kind === 'counter' ? 'Counter offer' : 'Offer'}>
        {displayValue(partner?.idOffer)}
      </Fact>
      <Fact label='Operation tolerance'>
        <OperationalToleranceSectionValue
          procurement={offerToleranceProcurement(
            procurement,
            partner,
            cargo?.requirement
          )}
        />
      </Fact>
    </Row>
  </RoomPanel>
);

export default GeneralInfoSection;
